import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import "../../../../assets/css/cms/Products.css";
import DataTable from "react-data-table-component";
import Select from "react-select";
import { Form, Row, Col } from "react-bootstrap";
import { Alert } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import Loading from "../../../utils/loader";
import { CUSTOM_STYLE_PERMISSION_DATA_TABLE } from "../../../../constants/cms";
import { Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
import { RiEdit2Line } from "react-icons/ri";
import "./webstory.css";
import UpdatedDateRangeFilter from "./dateRange";
import {Status , Languages} from "../../../../constants/articleApp";
import { getWebStoryList , getWebStoryFilterEntityType, getWebStoryFilterWebstoryTitle, getWebStoryFilterEntityName } from "../../../../../store/actions/cms/webStory";

const WebStories = () => {
  const dispatch = useDispatch();
  const [tableData, setTableData] = useState([]);
  const [creationDateRange, setCreationDateRange] = useState([null, null]);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsOnPage, setItemsOnPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [appliedFilters, setAppliedFilters] = useState({});
  const [debounceState, setDebounceState] = useState("");
  const [entityType, setEntityType] = useState("");
  const [entityMappings, setEntityMappings] = useState([
    { entity_type: null, entity_name: [] },
  ]);
  const {webStoryListData, webStoryFilterWebstoryTitleData, webStoryFilterEntityNameData, webStoryFilterEntityTypeData,webStoryListLoading} = useSelector(
    (state) => state.webStoryReducer
  );
  const totalPublished = webStoryListData?.total_published_stories || 0;
  const totalUnpublished = webStoryListData?.total_unpublished_stories || 0;
  const storyResults = Array.isArray(webStoryListData?.results)
    ? webStoryListData.results
    : [];
  const [tableCustomData, setTableCustomData] = useState([]);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
 
  //LISTING DATA
    useEffect(() => {
      setTableData(webStoryListData?.results)
      setTotalItems(webStoryListData?.totalRows || 0);
    }, [webStoryListData]);


  useEffect(() => {
    dispatch(getWebStoryList({ page: currentPage,limit: itemsOnPage,...appliedFilters}));
    setTableCustomData([
      {
        name: "S No.",
        selector: (row) => row.id,
        minWidth: "100px",
      },
      {
        name: "Story Title/Name",
        selector: (row) => row.title,
        center: true,
      },
      {
        name: "Created Date-Time",
        selector: (row) => row.created,
        center: true,
      },
      {
        name: "Updated Date-Time",
        selector: (row) => row.updated,
        center: true,
      },
      {
        name: "Status",
        selector: (row) => (row.status),
        center: true,
      },
      {
        name: "Action",
        selector: (row) => row.action,
        cell: (row) => (
          <div>
            <Link 
              to={`/cms/content/web-stories/add-edit/${row.id}`}>
              <span className="icon_edit">
                <RiEdit2Line />
              </span>
            </Link>
          </div>
        ),
        allowOverflow: true,
        center: true,
      },
    ])
  }, [currentPage])
  
  const formatDateToLocalYMD = (date) => {
    if (!date) return null;
    const tzOffset = date.getTimezoneOffset() * 60000; // offset in ms
    const localISO = new Date(date - tzOffset).toISOString().slice(0, 10); // 'YYYY-MM-DD'
    return localISO;
  };
  

  useEffect(() => {
  dispatch(getWebStoryFilterEntityType({ filter_type: "entity_type" }))
  }, [dispatch]);

  const statusOptions = [
    { value: 0, label: "Unpublished" },
    { value: 1, label: "Published" },
  ];
  
  const languageOptions = [
    { value: 44, label: "English" },
    { value: 66, label: "Hindi" },
  ];

  const fetchEntityNames = (entityTypeValue) => {
    if (!entityTypeValue) return;
    dispatch(
      getWebStoryFilterEntityName({
        filter_type: "entity_name",
        entity_type: entityTypeValue,
        term: "", 
      })
    );
  };


  const handleInputChange = (filter_type, value) => {
  
    let inDebounce = debounceState;
  
    const params = {
      filter_type,
      term: value,
    };
    if (filter_type === "entity_name" && entityType?.entity_type) {
      params.entity_type = entityType.entity_type;
    }
  
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => {
      if (filter_type === "webstory_title") {
        dispatch(getWebStoryFilterWebstoryTitle(params));
      }
      if (filter_type === "entity_name") {
        dispatch(getWebStoryFilterEntityName(params));
      }
    }, 1000);
  
    setDebounceState(inDebounce);
  };

  const isAnyFilterApplied = (values, dateRange, entityMappings) => {
    const entityTypeFilled = entityMappings[0]?.entity_type !== null;
    const entityNameFilled = Array.isArray(entityMappings[0]?.entity_name) && entityMappings[0].entity_name.length > 0;
  
    return (
      values.webstory_title !== null ||
      values.product_type !== null ||
      values.status !== null ||
      entityTypeFilled ||
      entityNameFilled ||
      (dateRange[0] !== null && dateRange[1] !== null)
    );
  };
  
  const handleChange = (index, field, value) => {
    const newMappings = [...entityMappings];
  
    if (field === "entity_type") {
      setEntityType(value);
      newMappings[index].entity_type = value;
      newMappings[index].entity_name = [];
      setEntityMappings(newMappings);
      if (value) {
        fetchEntityNames(value.value);
      }
    } else if (field === "entity_name") {
      newMappings[index].entity_name = value;
      setEntityMappings(newMappings);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  }
  
  const handlePerRowsChange = (newPerPage, page) => {
    setItemsOnPage(newPerPage);
    setCurrentPage(page);
  };

  return (
    <>
      <div className="news_letter_heading mx-0 mt-5">
        <h4>Manage Web Stories</h4>
      </div>

      <div className="custom_breadcrumb">
        <ul className="custom_breadcrumb_ul">
          <li className="custom_breadcrumb_list">
            <Link to="/cms/">
              <a className="sub_nan_anchor">Home</a>
            </Link>
          </li>
          <li className="custom_breadcrumb_list">
            <span>
              <FiChevronRight />
            </span>
          </li>
          <li className="custom_breadcrumb_list custom_breadcrumb_list_active">
            Manage Web Stories
          </li>
        </ul>
      </div>

      <div className="summary-boxes">
        <div className="summary-box">
          <span className="TotalCount">{totalPublished}</span>
          <br />
          Total Published Stories
        </div>
        <div className="summary-box">
          <span className="TotalCount">{totalUnpublished}</span>
          <br />
          Total Unpublished Stories
        </div>
      </div>
      <div className="examfilter">
        <Formik
          enableReinitialize
          initialValues={{
            webstory_title: null,
            product_type: null,
            status: null,
          }}
          onSubmit={(values) => {
            const filters = {};
          
            if (values.webstory_title) {
              filters.title = values.webstory_title.title; 
            }
            if (values.product_type) {
              filters.language_id = values.product_type.value;
            }
            if (entityMappings[0].entity_type) {
              filters.entity_type = entityMappings[0].entity_type.entity_type;
            }
            if (
              entityMappings[0].entity_name &&
              entityMappings[0].entity_name.length > 0
            )if (
              Array.isArray(entityMappings[0].entity_name) &&
              entityMappings[0].entity_name.length > 0
            ) {
              filters.entity_id = entityMappings[0].entity_name.map((e) => e.entity_id).join(',');
            }
          
            if (values.status) {
              filters.status = values.status.value;
            }
            if (creationDateRange[0] && creationDateRange[1]) {
              filters.created_start = formatDateToLocalYMD(creationDateRange[0]);
              filters.created_end = formatDateToLocalYMD(creationDateRange[1]);
            }
            
            setAppliedFilters(filters);
            if(currentPage!=1) setCurrentPage(1);
            setResetPaginationToggle(!resetPaginationToggle);
            dispatch(getWebStoryList({page: currentPage,limit: itemsOnPage,...filters}));
          }}
          
        >
          {({ handleSubmit, values, setFieldValue, resetForm }) => {
            useEffect(() => {
              setIsFilterActive(isAnyFilterApplied(values, creationDateRange, entityMappings));
            }, [values, creationDateRange, entityMappings]);

            return (
              <Form onSubmit={handleSubmit}>
                {entityMappings.map((mapping, index) => (
                  <Row key={index}>
                    <Col md={4} className="mb-3">
                      <Form.Group>
                        <label className="Dialer_form_label">Title</label>
                        <Select
                         name="webstory_title"
                         value={values.webstory_title} 
                         placeholder="Search WebStories by Title"
                         onChange={(option) => setFieldValue("webstory_title", option)}
                         onInputChange={(val) => handleInputChange('webstory_title', val)} 
                         getOptionLabel={(option) => option.title}
                         getOptionValue={(option) => option.id}
                         options={webStoryFilterWebstoryTitleData?.story_titles || []}
                         isClearable= {true}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4} className="mb-3">
                      <Form.Group>
                        <label className="Dialer_form_label">Language</label>
                        <Select
                          name="product_type"
                          value={values.product_type}
                          onChange={(option) =>
                            setFieldValue("product_type", option)
                          }
                          options={languageOptions}
                          placeholder="Select language"
                          isClearable
                          styles={{
                            menu: (base) => ({
                                ...base,
                                zIndex: '2'
                            }),
                          }}

                        />
                      </Form.Group>
                    </Col>
                    <Col md={4} className="mb-3">
                      <Form.Group>
                        <label className="Dialer_form_label">Entity Type</label>
                        <Select
                        name="entity_type"
                        value={mapping.entity_type}
                        onChange={(option) =>
                         handleChange(index, "entity_type", option)
                        }
                        getOptionLabel={(option) => option.entity_type}
                        getOptionValue={(option) => option.entity_type}
                        options={webStoryFilterEntityTypeData?.entity_types || null} 
                        placeholder="Entity type"
                        isClearable
                       />
                      </Form.Group>
                    </Col>
                    <Col md={4} className="mb-3">
                      <Form.Group>
                        <label className="Dialer_form_label">Entity Name</label>
                        <Select
                        name="entity_name"
                        value={mapping.entity_name}
                        onChange={(option) => handleChange(index, 'entity_name', option)}
                        onInputChange={(val) => handleInputChange('entity_name', val)}
                        onMenuOpen={() => {
                        if (mapping.entity_type?.entity_type) {
                        dispatch(getWebStoryFilterEntityName({
                         filter_type: "entity_name",
                         entity_type: mapping.entity_type.entity_type,
                         term: "" 
                         }));
                         }
                        }}
                       options={webStoryFilterEntityNameData?.entity_names || []}
                       getOptionLabel={(option) => option?.value}
                       getOptionValue={(option) => option?.entity_id}
                       placeholder="Entity name"
                       isDisabled={!mapping.entity_type}
                       isMulti
                       isClearable={false}
                       closeMenuOnSelect={false}
                      />
                      </Form.Group>
                    </Col>
                    <Col md={4} className="mb-3">
                      <Form.Group>
                        <label className="Dialer_form_label">
                          Creation Date Range
                        </label>
                        <UpdatedDateRangeFilter
                          dateRange={creationDateRange}
                          setDateRange={setCreationDateRange}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4} className="mb-3">
                      <Form.Group>
                        <label className="Dialer_form_label">Status</label>
                        <Select
                          name="status"
                          value={values.status}
                          onChange={(option) =>
                            setFieldValue("status", option)
                          }
                          options={statusOptions}
                          placeholder="Select status"
                          isClearable
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                ))}
                <Row>
                  <Col>
                    <div className="manage_ranking_button_cover">
                    <button
                     type="submit"
                     className={`exam_button rounded-pill ${!isFilterActive ? "disabled-button" : ""}`}
                     disabled={!isFilterActive}
                    >
                    Apply Filter(s)
                    </button>
                    <button
                    type="button"
                    className={`exam_button rounded-pill ${!isFilterActive ? "disabled-button" : ""}`}
                    disabled={!isFilterActive}
                    onClick={() => {
                    resetForm();
                    setCreationDateRange([null, null]);
                    setEntityMappings([{ entity_type: null, entity_name: [] }]);
                    setIsFilterActive(false);
                    setAppliedFilters(null);
                    setCurrentPage(1);
                    setResetPaginationToggle(!resetPaginationToggle);
                    dispatch(getWebStoryList({page: currentPage,limit: itemsOnPage}));
                    }}            
                    >
                    Clear Filter(s)
                    </button>
                    </div>
                  </Col>
                </Row>
              </Form>
            );
          }}
        </Formik>
      </div>
      

      <div className="all_task" style={{ marginTop: "40px" }}>
        <div className="examfilter">
          <div className="tablestrip">
            <div className="tablestrip_left">
              <h4 className="examfilter_heading">Web Stories</h4>
            </div>
            <div className="add_new">
                <a  className="add_new_btn" href="/cms/content/web-stories/add-edit" target="_parent">
                  Add New WebStory
                </a>
            </div>
          </div>

          <div
            className="exam_table_box web_story_table_cover"
            style={{ marginTop: "20px" }}
          >
            <DataTable
             columns={tableCustomData}
             data={tableData}
             customStyles={CUSTOM_STYLE_PERMISSION_DATA_TABLE}
             progressPending={webStoryListLoading}
             pagination
             paginationServer
             paginationPerPage={itemsOnPage}
             paginationTotalRows={totalItems}
             onChangePage={handlePageChange}
             onChangeRowsPerPage={handlePerRowsChange}
             paginationComponentOptions={{ noRowsPerPage: true }}
             paginationResetDefaultPage={resetPaginationToggle} 
             />
          </div>
        </div>
      </div>
    </>
  );
};

export default WebStories;
